<template>
  <div class="app-data-filter__group-item" :class="{ 'item-has-children': hasChildren }">
    <label class="item-label">
      <input v-model="model" type="checkbox" :value="valueAsScalar" />
      <span class="app-data-filter__group-item-title">{{ item.title }}</span>
    </label>
    <ul v-if="hasChildren" class="children">
      <li v-for="child in item.children" :key="`${uniqueId}-${child.id}`" class="children-item">
        <AppDataFilterCheckboxGroupChildItem v-model="childrenModel" :item="child" />
      </li>
    </ul>
  </div>
</template>

<script>
import { getItemValueAsScalar } from '@/helpers/data-filter/utils';
import AppDataFilterCheckboxGroupChildItem from '@/components/data-filter/AppDataFilterCheckboxGroupChildItem.vue';

export default {
  name: 'AppDataFilterCheckboxGroupItem',
  components: { AppDataFilterCheckboxGroupChildItem },
  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      required: true,
    },
    uniqueId: {
      type: String,
      required: true,
    },
  },

  computed: {
    hasChildren() {
      return Array.isArray(this.item.children) && this.item.children.length > 0;
    },

    valueAsScalar() {
      return getItemValueAsScalar(this.item);
    },

    childScalarValues() {
      return this.hasChildren ? this.item.children.map(getItemValueAsScalar) : [];
    },

    checkedChildValues() {
      return this.childScalarValues.filter((v) => this.value.includes(v));
    },

    valuesWithoutSelfAndChildren() {
      return this.value.filter((v) => v !== this.valueAsScalar && !new Set(this.childScalarValues).has(v));
    },

    childrenModel: {
      get() {
        return this.checkedChildValues;
      },
      set(selectedChildren) {
        // Selecting a child implicitly deselects the parent value.
        this.$emit('change', [...this.valuesWithoutSelfAndChildren, ...selectedChildren]);
      },
    },

    model: {
      get() {
        return this.checkedChildValues.length ? this.checkedChildValues : this.value;
      },
      set(newValue) {
        if (this.checkedChildValues.length) {
          // Toggling the parent while children are selected collapses
          // the selection down to just the parent value.
          this.$emit('change', [...this.valuesWithoutSelfAndChildren, this.valueAsScalar]);

          return;
        }

        this.$emit('change', newValue);
      },
    },
  },
};
</script>
